import type { ParseKeys } from 'i18next';

export type GroupMemberInvitationStatus = 'pending' | 'accepted' | 'expired' | 'invalid';

export namespace GroupMemberInvitationStatus {
  export function getLocalStringKey(status: GroupMemberInvitationStatus): ParseKeys {
    switch (status) {
      case 'pending':
        return 'group.invitationStatus.pending';
      case 'accepted':
        return 'group.invitationStatus.accepted';
      case 'expired':
        return 'group.invitationStatus.expired';
      case 'invalid':
        return 'group.invitationStatus.invalid';
    }
  }
}
